import $ from 'jquery';
import TweenMax from 'TweenMax';
import Power2 from 'animation.gsap';
import 'scrollTo';

export default class Header {
	constructor(options) {
		const defaults = {
			el: '.js-header',
			body: '.js-body',
			dom: {
				toggle: '.js-menu-header-toggle',
				toggleMobile: '.js-menu-header-mobile-toggle',
				popup: '.js-popup-menu',
				arrow: '.js-header-arrow-down',
				anchor: '.js-idea-wait',
				video: '.js-header-video',
				menu: {
					block: '.js--mobile-menu-block',
					toggle: '.js--menu-mobile-toggle',
					backSplash: '.js--menu-header__backsplash'
				},
				submenu: {
					block: '.js--menu-item__has-sub',
					toggle: '.js--menu-item__with-sub',
					sub: '.js--items__submenu'
				}
			},
			src: {
				video: 'video/main.mp4'
			},
			classes: {
				page: {
					state: {
						hidden: 'page_state_hidden'
					}
				},
				toggle: {
					state: {
						active: 'menu-header__toggle-menu_state_active',
						activeMobile: 'header__toggle-menu-mobile_state_active',
						animate: 'is--load-animate'
					}
				},
				popup: {
					state: {
						active: 'popup-menu_state_active'
					}
				},
				menu: {
					state: 'is--active'
				},
				submenu: {
					state: 'is--open'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$toggle = this.$el.find(this.options.dom.toggle);
		this.$toggleMobile = this.$el.find(this.options.dom.toggleMobile);
		this.$popup = this.$el.find(this.options.dom.popup);
		this.$page = this.$el.closest(this.options.body);
		this.$arrow = this.$el.find(this.options.dom.arrow);
		this.$anchor = $(this.options.dom.anchor);
		this.$video = $(this.options.dom.video);
		this.srcVideo = this.options.src.video;
		this.activePopup = this.options.classes.popup.state.active;
		this.activeToggle = this.options.classes.toggle.state.active;
		this.activeToggleMobile = this.options.classes.toggle.state.activeMobile;
		this.hidden = this.options.classes.page.state.hidden;
		this.loadAnimate = this.options.classes.toggle.state.animate;
		this.$menuBlock = this.$el.find(this.options.dom.menu.block);
		this.$toggleMenu = this.$el.find(this.options.dom.menu.toggle);
		this.openMenu = this.options.classes.menu.state;
		this.$subMenuBlock = this.$el.find(this.options.dom.submenu.block);
		this.$submenu = this.$el.find(this.options.dom.submenu.sub);
		this.$toggleSubMenu = this.$el.find(this.options.dom.submenu.toggle);
		this.openSubMenu = this.options.classes.submenu.state;
		this.$backsplash = this.$el.find(this.options.dom.menu.backSplash);
		return this;
	}

	onToggle() {
		this.$popup.toggleClass(this.activePopup);
		this.$toggle.toggleClass(this.activeToggle);
		this.$page.toggleClass(this.hidden);
		$('body').toggleClass('body_hidden');
	}


	onToggleMobile() {
		this.$popup.toggleClass(this.activePopup);
		this.$toggleMobile.toggleClass(this.activeToggleMobile);
		this.$page.toggleClass(this.hidden);
		$('body').toggleClass('body_hidden');
	}

	close() {
		this.$popup.removeClass(this.activePopup);
		this.$toggle.removeClass(this.activeToggle);
		this.$toggleMobile.removeClass(this.activeToggleMobile);
		this.$page.removeClass(this.hidden);
		$('body').removeClass('body_hidden');
	}

	scrollDown = () => {
		const pos = this.$anchor.offset().top;
		TweenMax.to(window, 0.6, {
			scrollTo: {y: pos, autoKill: false},
			ease: Power2.easeInOut
		});
	}

	videoSrc() {
		const $video = this.$video;
		const src = this.srcVideo;
		$video.attr('src', src);
	}

	onVideoFitRequest() {
		const $video = this.$video;
		const containerWidth = $video.parent().width();
		const containerHeight = $video.parent().height();
		const reverseRatio = $video[0].videoHeight / $video[0].videoWidth;

		if ((containerHeight / reverseRatio) < containerWidth) {
			$video.css({
				width: '100%', height: 'auto'
			});
		} else if ((containerWidth * reverseRatio) < containerHeight) {
			$video.css({
				width: 'auto', height: '100%'
			});
		} else {
			$video.css({
				width: '100%', height: '100%'
			});
		}
	}
	toggleByOrintation() {
		const width = window.innerWidth;
		const xs = 768;
		const isOpen = this.$popup.hasClass('popup-menu_state_active');

		if (width <= xs && isOpen) {
			this.$toggleMobile
				.addClass('header__toggle-menu-mobile_state_active');
		} else if (isOpen) {
			console.log('toogle 1');
			this.$toggle
				.addClass('menu-header__toggle-menu_state_active');
		}
	}
	toggleClassAnimate() {
		const element = this.$toggle;
		element.removeClass(this.loadAnimate);
	}

	setMobileMenuActive() {
		setTimeout(this.toggleByOrintation.bind(this), 300);
	}

	removeAnimateClass() {
		setTimeout(this.toggleClassAnimate.bind(this), 2000);
	}

	bindWindowEvents() {
		window.addEventListener('keydown', e => {
			if (e.keyCode === 27) {
				this.close();
			}
		});

		window.addEventListener('load', this.removeAnimateClass.bind(this));
		window.addEventListener('orientationchange', this.setMobileMenuActive.bind(this), false);
		window.addEventListener('resize', this.setMobileMenuActive.bind(this), false);
	}

	toggleMenu = () => {
		const menu = this.$menuBlock;
		const menuToggle = this.$toggleMenu;

		menu.toggleClass(this.openMenu);
		menuToggle.toggleClass(this.openMenu);
	}

	openCloseMenu = () => {
		const menuBlock = this.$menuBlock;

		if (menuBlock.hasClass(this.openMenu)) {
			menuBlock.fadeOut(150);
			document.body.classList.remove('body_hidden');
			document.body.classList.remove('is--active-mobile-menu');
		} else {
			menuBlock.fadeIn(150);
			document.body.classList.add('body_hidden');
			document.body.classList.add('is--active-mobile-menu');
		}
		this.toggleMenu();
	}

	toggleSubMenu = () => {
		const subMenu = this.$subMenuBlock;

		subMenu.toggleClass(this.openSubMenu);
	}

	openCloseSubMenu = slideDown => {
		const speed = 200;
		const subMenu = this.$submenu;
		const subMenuBlock = this.$subMenuBlock;
		const backSplash = this.$backsplash;

		if (subMenuBlock.hasClass(this.openSubMenu)) {
			if (slideDown) {
				subMenu.slideUp(speed);
			} else {
				subMenu.fadeOut(speed);
				backSplash.fadeOut(speed);
			}
		} else if (slideDown) {
			subMenu.slideDown(speed);
		} else {
			subMenu.fadeIn(speed);
			backSplash.fadeIn(speed);
		}
		this.toggleSubMenu();
	}

	openCloseSubMenuHover = () => {
		const speed = 200;
		const subMenu = this.$submenu;
		const subMenuBlock = this.$subMenuBlock;
		const backSplash = this.$backsplash;

		subMenu.fadeIn(speed);
		backSplash.fadeIn(speed);
		subMenuBlock.addClass(this.openSubMenu);
	}

	openCloseSubMenuUnHover = () => {
		const speed = 200;
		const subMenu = this.$submenu;
		const subMenuBlock = this.$subMenuBlock;
		const backSplash = this.$backsplash;

		subMenu.fadeOut(speed);
		backSplash.fadeOut(speed);
		subMenuBlock.removeClass(this.openSubMenu);
	}

	setMobileMenuHeight() {
		const vh = window.innerHeight * 0.01;

		document.documentElement.style.setProperty('--VIEW-height', `${vh}px`);
	}

	canUseWebP() {
		const elem = document.createElement('canvas');

		if (elem.getContext && elem.getContext('2d')) {
			return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
		}

		return false;
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$toggle.on('click', this.onToggle.bind(this));
			this.$toggleMobile.on('click', this.onToggleMobile.bind(this));
			this.$arrow.on('click', this.scrollDown);
			this.bindWindowEvents();
			if ($('body').hasClass('is--desktop')) {
				$(document).ready(this.videoSrc.bind(this));
			}
			const self = this;
			const ua = navigator.userAgent;
			const isIEorEdge = (/msie/i.test(ua) && !/opera/i.test(ua)) || /trident|edge/i.test(ua);
			if (isIEorEdge && this.$video.length) {
				this.onVideoFitRequest();
				$(window).on('resize', this.onVideoFitRequest.bind(this));
			}
			$('body').addClass('is-menu-init');

			// New Menu
			this.$toggleMenu.on('click', function (e) {
				e.preventDefault();
				self.openCloseMenu();
			});

			// SubMenu
			this.$toggleSubMenu.on('click', function (e) {
				e.preventDefault();
				const slideDown = $('body').hasClass('is--mobile') ? 1 : 0;

				self.openCloseSubMenu(slideDown);
			});

			// Desktop
			this.$subMenuBlock.mouseenter(function () {
				if ($('body').hasClass('is--desktop')) {
					self.openCloseSubMenuHover();
				}
			}).mouseleave(function () {
				if ($('body').hasClass('is--desktop')) {
					self.openCloseSubMenuUnHover();
				}
			});

			this.setMobileMenuHeight();
			window.onresize = this.setMobileMenuHeight;
		}

		if (this.canUseWebP()) {
			$('body').addClass('is--support-webp');
		} else {
			$('body').addClass('is--not-support-webp');
		}

		return this;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/header/header.js